import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'viggo-core-controls-action',
  templateUrl: './controls-action.component.html'
})
export class ControlsActionComponent {
  /**
   * @description
   * Evento emitter para quando o botão de reload é clicado
   */
  @Output() public readonly onReloadClick = new EventEmitter<void>();

  /**
   * @description
   * Evento emitido quando é clicado no botão de informação
   */
  @Output() public readonly onChangeInfoClik = new EventEmitter<void>();
  /**
   * @description
   * Evento emitido quando é clicado no botão de dowload de informações
   */
  @Output() public readonly onDownloadDataClik = new EventEmitter<void>();
  /**
   * @description
   * Evento emitido quando é clicado no botão de limpar os filtros
   */
  @Output() public readonly onClearFilters = new EventEmitter<void>();
  /**
   * Habilita o botao de donwload
   */
  @Input() showDownloadButton = true;
  /**
   * Habilita o botao de reload
   */
  @Input() showReloadButton = true;
  /**
   * Habilita o botao de informacao
   */
  @Input() showInfoButton = true;
  /**
   * Habilita o botao de informacao
   */
  @Input() showClearFilters = true;

  /**
  * Emite o evento de limpar os filtros
  */
  public clearFilter() {
    this.onClearFilters.emit();
  }
  /**
   * Emite o evento de download
   */
  public donwload() {
    this.onDownloadDataClik.emit();
  }

  /**
   * Emite o evento de reload
   */
  public reload() {
    this.onReloadClick.emit();
  }

  /**
   * Emite o evento de click nas informações
   */
  public info() {
    this.onChangeInfoClik.emit();
  }
}
